cb.define(['common/common_VM.Extend.js'], function () {
  var ST_st_returnapply_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var mode = viewmodel.getParams().mode;
	  var detailsModel = viewmodel.get("ReturnApplys");
	  if(detailsModel){
	  		//向后台传递行号
			detailsModel.setState('orderField', 'rowno');
			//单元格编辑之前判断该行商品是否启用批次管理和效期管理
			detailsModel.on('rowColChange', function(args) {
				 var currentRow = detailsModel.getRow(args.value.rowIndex);

				//如果商品启用批次管理，那么批次号可编辑、必输
			  if (args.value.columnKey == 'batchno_batchno') {
				if (currentRow.isBatchManage == true) {
				  detailsModel.setCellState(args.value.rowIndex, 'batchno_batchno', 'bIsNull', false);
				} else {
				  return false;
				}
			  }
			});
			//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期
			detailsModel.on('afterCellValueChange', function (data){
				switch (data.cellName) {
					case "product_cCode" : {
						detailsModel.setCellValue(data.rowIndex, 'batchno', null);
						detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
						detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_batchno',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define1',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define2',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define3',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define4',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define5',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define6',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define7',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define8',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define9',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define10',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define11',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define12',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define13',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define14',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define15',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define16',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define17',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define18',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define19',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define20',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define21',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define22',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define23',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define24',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define25',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define26',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define27',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define28',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define29',  null);
						detailsModel.setCellValue(data.rowIndex, 'batchno_define30',  null);
						detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
						detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
						break;
					}
				}
			});
      detailsModel.on("beforeInsertRowFromRefer", function (data) {
        let selectedRow = detailsModel.getSelectedRows()[0];
        if (selectedRow) {
          let row = data.row;
          let keys = Object.keys(selectedRow);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if(!row[key])
              row[key] = selectedRow[key];
          }
        }
      });
		}
      viewmodel.on('afterLoadData', function (data) {
        if (mode == "browse")
          viewmodel.get("bizstatus").setVisible(true);
        else
          viewmodel.get("bizstatus").setVisible(false);
		if(mode == "add")
		{
			var btnSubmit =viewmodel.get("btnSubmit");
			if(btnSubmit != undefined)
				btnSubmit.setVisible(false);
			var btnStoreOut =viewmodel.get("btnStoreOut");
			if(btnStoreOut != undefined)
				btnStoreOut.setVisible(false);
		}
		var statuss = viewmodel.get("bizstatus").getValue();
		if(mode == "edit" && statuss == 0)
		{
			var btnSubmit =viewmodel.get("btnSubmit");
			if(btnSubmit != undefined)
				btnSubmit.setVisible(false);
			var btnStoreOut =viewmodel.get("btnStoreOut");
			if(btnStoreOut != undefined)
				btnStoreOut.setVisible(false);
		}

		if(statuss == 0)
		{
			var btnStoreOut =viewmodel.get("btnStoreOut");
			if(btnStoreOut != undefined)
				btnStoreOut.setVisible(false);
		}

		if(statuss == 1|| statuss == 2 || statuss == 3 || statuss == 4)
		{
			var btnEdit =  viewmodel.get("btnEdit");
			if(btnEdit != undefined)
				btnEdit.setVisible(false);
			var btnDelete =viewmodel.get("btnDelete");
			if(btnDelete != undefined)
				btnDelete.setVisible(false);
			var btnSubmit =viewmodel.get("btnSubmit");
			if(btnSubmit != undefined)
				btnSubmit.setVisible(false);
			var btnStoreOut =viewmodel.get("btnStoreOut");
			if(btnStoreOut != undefined)
				btnStoreOut.setVisible(false);
		}

		if(statuss == 2 )
		{
			var btnStoreOut =viewmodel.get("btnStoreOut");
			if(btnStoreOut != undefined)
				btnStoreOut.setVisible(true);
		}
      })
	  viewmodel.get("inwarehouse_name").on('afterValueChange', function (data) {
		  var oldValue = data.oldValue;
		  var warehouse = data.value;
		  if(warehouse != undefined)
		  {
			  var org = warehouse.org;
			  var org_name = warehouse.org_name;
			  viewmodel.get("inorg_name").setValue(org_name);
			  viewmodel.get("inorg").setValue(org);
		  }
      })
	  viewmodel.get("inorg_name").on('afterValueChange', function (data) {
		  var oldValue = data.oldValue;
		  var org = data.value;
		  if(org != undefined)
		  {
			  viewmodel.get("inwarehouse_name").clear();
			  viewmodel.get("inwarehouse").clear();
		  }
      })
    }
  }
  try {
    module.exports = ST_st_returnapply_VM_Extend;
  } catch (error) {

  }
  return ST_st_returnapply_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_returnapply_VM.Extend.js